import { render, staticRenderFns } from "./trainsForm.vue?vue&type=template&id=582ad90a&scoped=true&"
import script from "./trainsForm.vue?vue&type=script&lang=js&"
export * from "./trainsForm.vue?vue&type=script&lang=js&"
import style0 from "./trainsForm.vue?vue&type=style&index=0&id=582ad90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ad90a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDataTable,VForm})
